import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ScribeLink from 'apps/scribe/ScribeLink';

const isProvidedOnlyWithoutTo = (props, propName, componentName) => {
  if (props.to && typeof props[propName] !== 'undefined') {
    return new Error(`Invalid prop \`${
      propName
    }\` supplied to \`${
      componentName
    }\`. You may not use disabled flag when using \`${
      componentName
    }\` as an anchor.`);
  }

  return null;
};

export default class TextLink extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    to: PropTypes.string,
    disabled: isProvidedOnlyWithoutTo,
    onClick: PropTypes.func,
    chevronDown: PropTypes.bool,
    children: PropTypes.node,
    target: PropTypes.string,
    secondary: PropTypes.bool,
  };

  render() {
    const { to, onClick, chevronDown, className, disabled, target, secondary } = this.props;
    const styles = classNames(
      'gn-textLink',
      {
        'gn-textLink--chevronDown': chevronDown,
        'gn-textLink--disabled': disabled,
        'gn-textLink--secondary': secondary,
      },
      className,
    );

    if (!to) {
      return (
        <button
          type="button"
          className={styles}
          onClick={onClick}
          disabled={disabled}
        >
          {this.props.children}
        </button>
      );
    }

    return (
      <ScribeLink
        to={to}
        className={styles}
        onClick={onClick}
        target={target}
      >
        {this.props.children}
      </ScribeLink>
    );
  }
}
